import React from 'react';
import {StickyContainer, Sticky} from 'react-sticky';

export default class SideMenu extends React.Component {
    render() {
        return <StickyContainer className="sticky-container">
            <Sticky distanceFromTop="15">
                {
                    ({ style }) => {
                        return (
                            <div className="side-menu" style={style}>
                                {this.props.children}
                            </div>
                        )
                    }
                }
            </Sticky>
        </StickyContainer>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/SideMenu.js